module.exports = __webpack_public_path__ + "static/media/logo.dfb0c878.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 301
// module chunks = 0